import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es5.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { printStructuredData } from '@sparta.global.helpers/structured-data-helper/dist/es5.js';
var Template = Handlebars.template({
  "1": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return (stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = depth0 != null ? lookupProperty(depth0, "global") : depth0) != null ? lookupProperty(stack1, "structuredData") : stack1, {
      "name": "each",
      "hash": {},
      "fn": container.program(2, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 2,
          "column": 2
        },
        "end": {
          "line": 6,
          "column": 11
        }
      }
    })) != null ? stack1 : "";
  },
  "2": function _(container, depth0, helpers, partials, data) {
    var lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }
      return undefined;
    };
    return "    <script type=\"application/ld+json\">\r\n    " + container.escapeExpression((lookupProperty(helpers, "printStructuredData") || depth0 && lookupProperty(depth0, "printStructuredData") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, depth0, {
      "name": "printStructuredData",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 4,
          "column": 4
        },
        "end": {
          "line": 4,
          "column": 32
        }
      }
    })) + "\r\n    </script>\r\n";
  },
  "4": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return (stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "structuredData") : depth0, {
      "name": "each",
      "hash": {},
      "fn": container.program(2, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 9,
          "column": 2
        },
        "end": {
          "line": 13,
          "column": 11
        }
      }
    })) != null ? stack1 : "";
  },
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = depth0 != null ? lookupProperty(depth0, "global") : depth0) != null ? lookupProperty(stack1, "structuredData") : stack1, {
      "name": "if",
      "hash": {},
      "fn": container.program(1, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 7,
          "column": 7
        }
      }
    })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "with").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "seoData") : depth0, {
      "name": "with",
      "hash": {},
      "fn": container.program(4, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 8,
          "column": 0
        },
        "end": {
          "line": 14,
          "column": 9
        }
      }
    })) != null ? stack1 : "");
  },
  "useData": true
});
var renderTemplate = function renderTemplate(data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global.modules/semantic-markup-module",
  "version": "1.0.4",
  "id": "semanticMarkupModule",
  "containerID": "globalSemanticMarkupModule",
  "moduleName": "global-semantic-markup-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "semantic-markup-module",
  "data": {
    "options": {},
    "init": "GlobalSemanticMarkupModule"
  },
  "moduleParams": [{
    "name": "pageSelector",
    "type": "string",
    "default": "",
    "description": ""
  }],
  "layout": "layout",
  "render": function render(context) {
    return renderTemplate(context, {
      "helpers": {
        printStructuredData: printStructuredData
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    printStructuredData: printStructuredData
  },
  "dependencies": {
    "@sparta.global.helpers/structured-data-helper": "^1.0.2",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.5",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jquery": "^3.5.1"
  },
  "stores": []
};
var SemanticMarkupModule = /*#__PURE__*/function (_Module) {
  function SemanticMarkupModule(options) {
    _classCallCheck(this, SemanticMarkupModule);
    return _callSuper(this, SemanticMarkupModule, [_objectSpread(_objectSpread({}, options), {}, {
      config: _moduleConfig
    })]);
  }
  _inherits(SemanticMarkupModule, _Module);
  return _createClass(SemanticMarkupModule, [{
    key: "init",
    value: function init() {
      // Do nothing.
    }
  }]);
}(Module);
registerModuleClass({
  moduleClass: SemanticMarkupModule,
  moduleConfig: _moduleConfig
});
var moduleConfig = _moduleConfig;
export { SemanticMarkupModule as default, moduleConfig };